import ReleaseNotesIcon from '@material-ui/icons/Cached';
import { ResourceExport } from '../../types/resource-export.type';
import ReleaseNotesList from './ReleaseNotesList';

const ReleaseNotes: ResourceExport = {
  list: ReleaseNotesList,
  icon: ReleaseNotesIcon,
};
export default ReleaseNotes;
